import styled, { css } from "styled-components";
import { NAV_ITEM_HEIGHT } from "theme/constants";
const Navbar = styled.header(
  ({ theme }) => css`
    position: relative;
    height: ${NAV_ITEM_HEIGHT};
    min-height: auto;
    display: flex;
    align-items: center;

    flex-wrap: nowrap;
    background-color: ${theme.colors.global.navigationBackground};
    border: 0;
    padding: 0;
    box-shadow: 0 3px 3px ${theme.colors.global.navigationBoxShadow};
    margin-bottom: 0;
    font-family: ${theme.fonts.family.navigation};
    font-size: ${theme.fonts.size.navigation};
  `
);
export default Navbar;
